import $ from "jquery";
import GLightbox from "glightbox";
import initializeTooltip from "./utils/tooltips";
import { initOtherFieldsToggle } from "./utils/formHelpers";
import { initializeSelect2 } from "./utils/select2Helpers";
import { initEmblaCarousel, initEmblaCarouselGallery } from "./utils/emblaCarousel";
import initPageToc from "./pageToc";
import initShareButton from "./shareButton";

function initGLightbox(target) {
  const fragmentSelector = `[data-fragment-id="${target.dataset.fragmentId}"]`;

  // Get all unique gallery IDs within this fragment
  const glightboxElements = target.querySelectorAll(".glightbox[data-gallery]");
  const galleryIds = [
    ...new Set([...glightboxElements].map((el) => el.dataset.gallery)),
  ];

  // Initialize a separate GLightbox instance for each gallery group
  galleryIds.forEach((galleryId) => {
    GLightbox({
      selector: `${fragmentSelector} .glightbox[data-gallery="${galleryId}"]`,
      width: "90vw",
      height: "90vh",
    });
  });

  // Also handle any glightbox elements without data-gallery (fallback)
  const ungroupedElements = target.querySelectorAll(
    ".glightbox:not([data-gallery])",
  );
  if (ungroupedElements.length > 0) {
    GLightbox({
      selector: `${fragmentSelector} .glightbox:not([data-gallery])`,
      width: "90vw",
      height: "90vh",
    });
  }
}

function initFileDragHighlight(target) {
  target.querySelectorAll("input[type=file]").forEach(function (input) {
    function add() {
      input.classList.add("is-dragover");
    }
    function remove() {
      input.classList.remove("is-dragover");
    }
    ["dragenter", "dragover"].forEach(function (evt) {
      input.addEventListener(evt, add);
    });
    ["dragleave", "drop", "dragend"].forEach(function (evt) {
      input.addEventListener(evt, remove);
    });
  });
}

function initTabLinks(target) {
  target.querySelectorAll("a[data-update-field]").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var field = document.getElementById(link.dataset.updateField);
      if (!field) return;
      field.value = link.dataset.value || "";
      link.closest("nav").querySelectorAll("[aria-current]").forEach(function (a) {
        a.removeAttribute("aria-current");
      });
      link.setAttribute("aria-current", "page");
      field.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
}

export default function initWidgets(target) {
  if (!("fragmentId" in target.dataset)) {
    target.dataset.fragmentId = crypto.randomUUID();
  }

  initGLightbox(target);

  $("select.select2", target).each(function (index, el) {
    initializeSelect2(el);
  });

  initOtherFieldsToggle(target);

  initFileDragHighlight(target);

  target.querySelectorAll("[data-toggle=tooltip]").forEach(function (el) {
    initializeTooltip(el);
  });

  initTabLinks(target);

  target.querySelectorAll("[data-embla]").forEach(initEmblaCarousel);
  target.querySelectorAll("[data-embla-gallery]").forEach(initEmblaCarouselGallery);

  initPageToc(target);
  initShareButton(target);

  var calendarEl = target.querySelector("[data-calendar]");
  if (calendarEl) {
    import("./calendar/index.js").then(function ({ initCalendar }) {
      initCalendar(calendarEl);
    });
  }
}
